"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateLicenseTc = exports.getLicenseTcs = exports.getLicenseTcById = exports.defaultLicenseTcData = exports.createLicenseTc = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
const defaultLicenseTcData = exports.defaultLicenseTcData = {
  id: undefined,
  name: '',
  description: '',
  enabled: true
};
const getLicenseTcs = query => (0, _request.default)({
  url: '/license-tc',
  method: 'get',
  params: query
});
exports.getLicenseTcs = getLicenseTcs;
const getLicenseTcById = id => (0, _request.default)({
  url: `/license-tc/${id}`,
  method: 'get'
});
exports.getLicenseTcById = getLicenseTcById;
const createLicenseTc = data => (0, _request.default)({
  url: '/license-tc',
  method: 'post',
  data
});
exports.createLicenseTc = createLicenseTc;
const updateLicenseTc = (id, data) => (0, _request.default)({
  url: `/license-tc/${id}`,
  method: 'patch',
  data
});
exports.updateLicenseTc = updateLicenseTc;